/**
 * This file contains the style for the About component using Material-UI.
 * @name AboutMUIStyle
 * @category MUI
 * @returns {Object} The style object.
 */
const style = () => ({
	dialogBox: {
		"& .MuiDialogContentText-root": {
			margin: 0,
		},
		"& .MuiTypography-colorTextSecondary": {
			color: "inherit",
		},
		"& .MuiDialog-paperScrollPaper": {
			maxHeight: `calc(100% - 264px)`,
		},
	},

	link: {
		"&:hover": {
			textDecoration: "none",
		},
	},
	table: {
		minWidth: 700,
	},
	tableContainer: {
		maxHeight: 400,
	},
	dialogTitle: {
		fontSize: "1.5rem",
		fontWeight: 500,
		lineHeight: 1.235,
	},
	h2Logo: {
		height: "8rem",
	},
	article: {
		color: "rgba(0, 0, 0, 0.6)",
	},
});
export default style;
